<template>
    <div :id="id" class="modal fade">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <slot name="title"></slot>
                    </h5>
                    <button
                        type="button"
                        class="close"
                        @click="close"
                        :aria-label="t('info_modal-close')"
                    ><Icon icon-class="ui-x-close" size="4" /></button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        ref="btnClose"
                        class="btn btn-success"
                        @click="close"
                    >
                        <slot name="confirm">{{ t('info_modal-close') }}</slot>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import Icon from "../../components/icon/icon";

export default {
    name: "info-modal",
    components: { Icon },
    props: {
        id: String,
        startsOpen: {
            type: Boolean,
            default: false,
        },
        isDismissible: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        $: function () {
            return $("#" + this.id);
        },
    },
    mounted: function () {
        let isDismissible = !this.isDismissible
            ? { backdrop: "static", keyboard: false }
            : {};
        this.$.modal({ show: this.startsOpen, ...isDismissible });

        window.addEventListener("popstate", this.handlePopState);
    },
    beforeUnmount: function () {
        window.removeEventListener("popstate", this.handlePopState);
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        open: function () {
            this.$.modal("show");
            window.setTimeout(() => {
                if (this.$refs.btnClose) {
                    this.$refs.btnClose.focus();
                }
            }, 500);
            this.$emit("open");
        },
        close: function () {
            this.$.modal("hide");
            this.$emit("close");
        },
        handlePopState: function () {
            this.close();
        },
    },
};
</script>
